import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CsrfTokenService {
  private readonly STORAGE_KEY = 'zsn-csrf-token';

  public setToken(token: string): void {
    localStorage.setItem(this.STORAGE_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  public clearToken(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
